import { QuoteStatus } from '../enums/quoteStatus'

export const pendingQuoteStatuses = [QuoteStatus.Created, QuoteStatus.Open, QuoteStatus.Sent, QuoteStatus.Unsent]
